import { createApp } from "vue";
import NavPreHome from "./NavPreHome.vue";

const app = createApp({
  components: {
    "nav-pre-home": NavPreHome,
  },
}).mount("#container-nav-pre-home");
